module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioSegundoExamenReg2FIS3.25293a9b.pdf";